/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
import '../resources/credit_limit_adjustment';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "UpdateCreditLimitRequest": {
                "fields": {
                  "creditLimitAdjustmentIdentifier": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "accept": {
                    "type": ".squareup.corporate_card.service.UpdateCreditLimitRequest.Accept",
                    "id": 2
                  },
                  "decline": {
                    "type": ".squareup.corporate_card.service.UpdateCreditLimitRequest.Decline",
                    "id": 3
                  }
                },
                "nested": {
                  "Accept": {
                    "fields": {
                      "creditLimitAmount": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "Decline": {
                    "fields": {}
                  },
                  "Type": {
                    "oneof": ["accept", "decline"]
                  }
                }
              },
              "UpdateCreditLimitResponse": {
                "fields": {
                  "creditLimitAdjustment": {
                    "type": ".squareup.corporate_card.resources.CreditLimitAdjustment",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.UpdateCreditLimitRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.UpdateCreditLimitRequest?.nested?.Accept && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.UpdateCreditLimitRequest?.nested?.Decline && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.UpdateCreditLimitResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateCreditLimitRequest @ squareup/corporate_card/service/update_credit_limit.proto at 11:1
 */
export const UpdateCreditLimitRequest = $root.lookupType('squareup.corporate_card.service.UpdateCreditLimitRequest');
fixType(UpdateCreditLimitRequest, {
  creditLimitAdjustmentIdentifier: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateCreditLimitRequest);
/**
 * SOURCE Accept @ squareup/corporate_card/service/update_credit_limit.proto at 12:4
 */
UpdateCreditLimitRequest.Accept = $root.lookupType('squareup.corporate_card.service.UpdateCreditLimitRequest.Accept');
fixType(UpdateCreditLimitRequest.Accept);
Builder.createAndAttachToType(UpdateCreditLimitRequest.Accept);
/**
 * SOURCE Decline @ squareup/corporate_card/service/update_credit_limit.proto at 19:4
 */
UpdateCreditLimitRequest.Decline = $root.lookupType('squareup.corporate_card.service.UpdateCreditLimitRequest.Decline');
fixType(UpdateCreditLimitRequest.Decline);
Builder.createAndAttachToType(UpdateCreditLimitRequest.Decline);
/**
 * SOURCE UpdateCreditLimitResponse @ squareup/corporate_card/service/update_credit_limit.proto at 35:1
 */
export const UpdateCreditLimitResponse = $root.lookupType('squareup.corporate_card.service.UpdateCreditLimitResponse');
fixType(UpdateCreditLimitResponse);
Builder.createAndAttachToType(UpdateCreditLimitResponse);